<template>
    <div class="single-product-combination__body">
        <label
                v-for="(combination, index) in combinations"
                :key="combination.id_product_attribute"
                class="single-product-combination__item-wrapper row"
                :class="{'single-product-combination__item-wrapper--unavailable': !combination.available_now, 'single-product-combination__item-wrapper--active': selectedCombination?.id_product_attribute === combination.id_product_attribute}"
                @click="handleSelectedCombination(combination)"
        >
            <div class="col-1 pl-0 pl-md-1 pl-lg-2 d-flex align-items-center single-product-combination__radio-button-wrapper">
                <div class="single-product-combination__radio-button">
                    <input
                            type="radio" name="product_selection" :hidden="!combination.available_now"
                            :checked="selectedCombination?.id_product_attribute === combination.id_product_attribute"
                    >
                    <span class="single-product-combination__radio-button-checkmark"></span>
                </div>

            </div>
            <div class="col-11 pl-0 pl-md-3 single-product-combination__item">
                <div
                        class="single-product-combination__product-information-wrapper row"
                        :class="{'algolia-listing-product-block__product-option-item--unavailable': !combination.available_now, 'single-product-combination__product-information-wrapper--active': selectedCombination?.id_product_attribute === combination.id_product_attribute}"
                >
                    <div
                            class="algolia-listing-product-block__product-amount-wrapper col-4"
                    >
                        <div>
                            <div
                                class="algolia-listing-product-block__product-amount"
                                :title="combination.attribute_name"
                            >
                                {{ truncate(combination.attribute_name , 24) }}
                            </div>
                            <ProductCombinationPromotionText
                                v-if="combination.attribute_promotion_name"
                                :name="combination.attribute_promotion_name"
                            />
                            <ProductCombinationMqcText
                                :product-attribute-id="combination.id_product_attribute"
                            />
                        </div>
                        <div
                            v-if="truncate(combination.attribute_name, 24) !== combination.attribute_name"
                            class="algolia-listing-product-block__mobile-tooltip-button algolia-listing-product-block__mobile-tooltip-button--pdp"
                            @click="toggleTooltip($event, true, index)"
                        >
                            <i class="fal fa-info-circle"></i>
                        </div>
                        <div
                            v-if="tooltipIsOpen[index]"
                            @click.self="preventClosingTooltip"
                            class="algolia-listing-product-block__mobile-tooltip algolia-listing-product-block__mobile-tooltip--pdp"
                        >
                            <div class="d-flex justify-content-between mb-1">
                                <span class="mt-1" v-text="combination.attribute_name"></span>
                                <div class="algolia-listing-product-block__mobile-tooltip-close-button" @click="toggleTooltip($event, false, index)">
                                    <i class="fas fa-times-circle"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-8">
                        <PricingReductionSingleProduct
                                v-if="combination.price_reduction && combination.available_now"
                                :combination="combination"
                        />
                        <PricingNormalSingleProduct
                                v-else-if="combination.available_now && !hasUnavailableStatus(combination) && !combination.bundle_discount"
                                :combination="combination"
                                :promotion="combination.attribute_promotion_name"
                        />
                        <PricingDiscountSingleProduct
                                v-else-if="combination.available_now && !hasUnavailableStatus(combination) && combination.bundle_discount"
                                :combination="combination"
                        />
                        <PricingNotAvailableSingleProduct
                                v-else
                                :lang-iso="langIso"
                                :combination="combination"
                        />
                    </div>
                </div>
            </div>
        </label>
    </div>
    <div class="row single-product-combination__footer">


        <div class="col-12 offset-lg-1 col-lg-11 single-product-combination__buy-block-wrapper">
            <div class="row">
                <div class="col-12 offset-lg-2 col-lg-10">
                    <p class="text--red-400" v-show="showNoItemSelectedError">
                        {{ $t('blockCart.noItemSelected') }}
                    </p>
                </div>
            </div>

            <div class="row">
                <div class="col-3 col-md-2 pl-md-0 pl-lg-3 single-product-combination__buy-block-wrapper-buy-block-amount-input">
                    <AmountInput
                            :id-product-attribute="selectedCombination?.id_product_attribute"
                            :id-product="product?.id"
                    />
                </div>
                <div
                        v-if="!hasUnavailableStatus(selectedCombination)"
                        class="col-9 col-md-10 d-flex align-items-center pl-0 pl-md-3"
                >
                    <button
                            class="algolia-listing-product-block__buy-button w-100"
                            @click="onAddToCartClick(product.id, selectedCombination?.id_product_attribute, selectedCombination?.minimal_quantity)"
                            data-dismiss="modal"
                    >
                        <div class="mr-3 text--md">{{ $t("blockCart.addToCart") }}</div>
                        <i class="fa fa-shopping-cart"></i>
                    </button>
                </div>

                <div v-else class="col-9 col-md-10 d-flex align-items-center pl-0 pl-md-3">
                    <button
                            @click.prevent="handleOutOfStock(selectedCombination)"
                            class="algolia-listing-product-block__buy-button algolia-listing-product-block__buy-button--unavailable"
                    >
                        <i class="fa fa-envelope"></i>
                    </button>
                </div>

                <input type="hidden" name="token" :value="staticToken"/>
                <input type="hidden" name="id_product" :value="product?.id"/>
                <input type="hidden" name="add" :value="true"/>
                <input type="hidden" name="id_product_attribute" :value="selectedCombination?.id_product_attribute"/>
                <input type="hidden" name="group_4" :value="selectedCombination?.attributes[0]"/>
            </div>
        </div>
        <div class="col-12 single-product-combination__delivery-promise-wrapper">
            <div class="row">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed, onBeforeMount, onMounted, ref } from "vue";
import AmountInput from "./Inputs/AmountInput.vue";
import PricingNormalSingleProduct from "./Pricing/PricingNormalSingleProduct.vue";
import PricingNotAvailableSingleProduct from "./Pricing/PricingNotAvailableSingleProduct.vue";
import PricingReductionSingleProduct from "./Pricing/PricingReductionSingleProduct.vue";
import PricingDiscountSingleProduct from "./Pricing/PricingDiscountSingleProduct.vue";
import ProductCombinationPromotionText from "./ProductCombinationPromotionText.vue";
import ProductCombinationMqcText from "./ProductCombinationMqcText.vue";
import { isFeatureEnabled } from "../../js/helper/ab-test-helper";

const props = defineProps({
    combinations: {
        type: Object,
        required: true,
    },
    cartLink: {
        type: String,
        required: true,
    },
    staticToken: {
        type: String,
        required: true,
    },
    product: {
        type: Object,
        required: true,
    },
    shoppingIdProductAttribute: {
        type: Number,
        required: false,
    },
    isMobile: {
        type: Boolean,
        required: true,
        default: false,
    },
    langIso: {
        type: String,
        required: true,
        default: false,
    }
});


const algoliaItem = ref(null);

const emit = defineEmits(['out-of-stock', 'buy']);

onMounted(() => {
    const localStorageItem = JSON.parse(window.localStorage.getItem('algoliaProductPageItem'));
    if (localStorageItem) {
        algoliaItem.value = localStorageItem;

        window.localStorage.removeItem('algoliaProductPageItem');
    }
})

const handleOutOfStock = (combination) => {
    if (!combination) {
        return false;
    }

    emit("out-of-stock");
    $("#out-of-stock-opt-in-modal").removeClass("d-none");
    $("#out-of-stock-optin-attribute").val(combination.id_product_attribute);
};

const selectedCombination = ref(null);
const showNoItemSelectedError = ref(false);

const tooltipIsOpen = ref([]);

const isValidProductSelection = computed(() => {
    return true;
});

onMounted(() => {
    const filteredItem = Object.entries(props.combinations)
                               .filter(([key, item]) => item.id_product_attribute === parseInt(props.shoppingIdProductAttribute));

    if (filteredItem[0]) {
        selectedCombination.value = filteredItem[0][1] ?? null
    }

    document.addEventListener('click', () => {
        tooltipIsOpen.value.forEach((tooltip, tooltipKey) => tooltipIsOpen.value[tooltipKey] = false);
    });
})

const hasUnavailableStatus = (combination) => {
    if (!combination) {
        return false;
    }
    return (
        !combination.available_now ||
        combination.unavailable_status_text
    );
};

const onAddToCartClick = (id_product, id_combination, minimal_quantity) => {
    if (! selectedCombination.value) {

        if (props.isMobile) {
            window.EventBus.$emit('open-price-display-explanation-modal');

            return;
        }

        function scrollToTargetAdjusted(){
            const element = document.getElementById('js_product_single');
            const headerOffset = document.getElementById('js-header').getBoundingClientRect().height * 1.5;
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }

        document.querySelector('.algolia-listing-product-block__buy-button')
                .getBoundingClientRect().y < 400 ?
            scrollToTargetAdjusted() : null;



        showNoItemSelectedError.value = true;

        document.querySelectorAll('.single-product-combination__item').forEach((item) => {
            item.classList.add('shaking-container');
        })

        setTimeout(() => {
            document.querySelectorAll('.single-product-combination__item')
                    .forEach((item) => {
                        item.classList.remove('shaking-container');
                    });
        }, 1000);

        setTimeout(() => showNoItemSelectedError.value = false, 10000)

        return ;
    }


    if (algoliaItem.value) {

        setQueryIdInLocalStorage(algoliaItem.value.objectID, algoliaItem.value.__position, algoliaItem.value.__queryID);

        let event = {
            eventType: 'click',
            index: algolia_index,
            eventName: 'Product Added To Cart from Product Detail',
            objectIDs: [`${algoliaItem.value.objectID}`]
        };

        if(algoliaItem.value.__queryID){
            event.queryId = algoliaItem.value.__queryID;
            event.positions = [algoliaItem.value.__position];
        }

        if (typeof aa === 'function') {
            sendAlgoliaEvent(event)
        }
    }



    const elButton = document.createElement('button');

    elButton.dataset.idProduct          = id_product;
    elButton.dataset.idProductAttribute = id_combination;
    elButton.dataset.minimalQuantity    = minimal_quantity;

    if  (algoliaItem.value) {
        elButton.dataset.queryId = algoliaItem.value.__queryID;
        elButton.dataset.position = algoliaItem.value.__position;
        elButton.dataset.objectId = algoliaItem.value.objectID;
    }

    elButton.classList.add('d-none', 'product-list__item__add-to-cart-button');
    document.body.appendChild(elButton);

    elButton.click();
    elButton.remove();

    emit('buy');
};

const handleSelectedCombination = (combination) => {
    selectedCombination.value     = combination;
    showNoItemSelectedError.value = false;
}

const preventClosingTooltip = (event) => {
    event.stopPropagation();
    event.preventDefault();
}

const toggleTooltip = (event, preventPropagation, index) => {
    if (preventPropagation) {
        preventClosingTooltip(event);
    }

    if (typeof tooltipIsOpen.value[index] === 'undefined') {
        tooltipIsOpen.value[index] = true;

        return;
    }

    tooltipIsOpen.value[index] = !tooltipIsOpen.value[index];
}


const truncate = (data,num) => {
    let truncatedString = data.split("").slice(0, num).join("");

    if (truncatedString !== data) {
        truncatedString += '...';
    }

    return truncatedString;
}


</script>
